export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
};
export const SKINS = {
    standard: 'standard',
    error: 'error',
    success: 'success',
    premium: 'premium',
    disabled: 'disabled',
    primary: 'primary',
};
export const WEIGHTS = {
    thin: 'thin',
    normal: 'normal',
    bold: 'bold',
};
//# sourceMappingURL=constants.js.map